import { Injectable } from '@angular/core';
import { DialogService } from '../dialogs/dialog.service';
import { LoggerService } from './logger.service';
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SignatureService {
  signatures = undefined;
  savingSignature = false;
  deletingSignature = false;

  constructor(private logger: LoggerService, private dialogs: DialogService, private http: HttpClient) {
    
  }
  parseSignatureData(signatures) {
    signatures.map(s => {
      try {
        if (s.data && typeof (s.data) === 'string') {
          s.data = JSON.parse(s.data);
        }
      } catch (e) {
        this.logger.logInternalError('parseSignatureData - error parsing signature', e);
      }
    });
  }

  checkSignature() {
    this.dialogs.openMessageDialog("Login", "You need to login to your Vanaia account to use signatures feature"/*, () { console.log("OK"); }*/);
  }

  isSignatureSaving() {
    return this.savingSignature;
  }

  isSignatureDeleting() {
    return this.deletingSignature;
  }

  getSignatureList() {

    if (this.signatures && this.signatures.length !== 0) {
      return new Promise((resolve, reject) => {
          resolve({ status: 0, signatures: this.signatures });
      });
    }

    var promise = new Promise((resolve, reject) => {
      this.http.get("api/signatures").subscribe({
        next: (data: any) => {
          if (data && data.signatures) {
            this.parseSignatureData(data.signatures);
          }
          this.signatures = data.signatures;
          resolve(data)
        },
        error: (err: Error) => reject(this.logger.logApiError(err, "getSignatureList"))
      });
    });
    return promise;
  }

  deleteSignature(id) {

    this.deletingSignature = true;

    var promise = new Promise((resolve, reject) => {
      this.http.delete("api/signatures/" + id).subscribe({
        next: (data: any) => {
          this.signatures = this.signatures.filter(s => { return s.id !== id });
          this.deletingSignature = false;
          resolve(data)
        },
        error: (err: Error) => reject(this.logger.logApiError(err, "deleteSignature"))
      });
    });
    return promise;
  }

  applySignatureFilter(doc, page, data, fileType) {
    var promise = new Promise((resolve, reject) => {
      this.http.post("api/page/imagefilter?document=" + doc + "&page=" + page + "&filter=signature&filetype=" + fileType, data).subscribe({
        next: (data: any) => {
          this.deletingSignature = false;
          resolve(data)
        },
        error: (err: Error) => reject(this.logger.logApiError(err, "applySignatureFilter"))
      });
    });
    return promise;
  }

  prepareImageToInsertToDoc(doc, page, data, fileType) {
    var promise = new Promise((resolve, reject) => {
      this.http.post("api/page/imagefilter?document=" + doc + "&page=" + page + "&filter=signaturepng&filetype=" + fileType, data).subscribe({
        next: (data: any) => resolve(data),
        error: (err: Error) => reject(this.logger.logApiError(err, "prepareImageToInsert"))
      }); 
    });
    return promise;
  }

  getImageForTextSignature(txt, font) {
    var promise = new Promise((resolve, reject) => {
      this.http.post("api/textsignature", { text: txt, font: font }).subscribe({
        next: (data: any) => resolve(data),
        error: (err: Error) => reject(this.logger.logApiError(err, "getImageFotTextSignature"))
      });
    });
    return promise;
  }

  saveSignature(signature, description) {

    this.savingSignature = true;
    var promise = new Promise((resolve, reject) => {
      this.http.post("api/signatures", { Signature: signature, Description: description }).subscribe({
        next: (data: any) => {
          if (data && data.signatures) {
            this.parseSignatureData(data.signatures);
            this.signatures = data.signatures;
          }
          this.savingSignature = false;
          resolve(data)
        },
        error: (err: Error) => {
          this.savingSignature = false;
          reject(this.logger.logApiError(err, "saveSignatureList"))
        }
      });
    });
    return promise;
  }

  getSignature(id) {

    if (this.signatures) {
      var sig = this.signatures.filter((s) => { return s.id === id });

      if (sig.length >= 0) {
        return new Promise((resolve) => {
            resolve({ status: 0, signature: sig[0].data });
        });
      }
    }
    var promise = new Promise((resolve, reject) => {
      this.http.get("api/signatures/" + id).subscribe({
        next: (data: any) => resolve(data),
        error: (err: Error) => reject(this.logger.logApiError(err, "getSignature"))
      });
    });
    return promise;

  }
}
